export interface GetAntrepoOfferListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetAntrepoOfferListPagingAndFilterResponseData
}

export interface GetAntrepoOfferListPagingAndFilterResponseData {
    items: GetAntrepoOfferListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetAntrepoOfferListPagingAndFilterResponseItem {
    antrepoOfferId: string
    companyId: string
    refNo: string
    selectedCompanyId: string
    selectedPersonAuthorizedPersonId: string
    selectedPersonAuthorizedPersonPhone: string
    selectedPersonAuthorizedPersonEmail: string
    startDate: string
    endDate: string
    offerStatusId: string
    selectedCompanyName: string
    selectedPersonAuthorizedPersonName: string
    offerStatusName: string
    offerStatusAdditionalValue1: string
    antrepoOfferDetails: GetAntrepoOfferListPagingAndFilterResponseAntrepoOfferDetail[]
    fileArchives: GetAntrepoOfferListPagingAndFilterResponseFileArc[]
    antrepoOfferDate: string
    /** Oluşturma tarihi (gg.aa.yyyy). */
    createdDateStr?: string
    offerStatusChangeDate: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetAntrepoOfferListPagingAndFilterResponseAntrepoOfferDetail {
    antrepoOfferDetailId: string
    antrepoOfferId: string
    serviceId: string
    multiplier1Id: string
    multiplier2Id: string
    unitPrice: number
    currencyTypeId: string
    description: string
    serviceName: string
    multiplier1Name: string
    multiplier2Name: string
    currencyTypeName: string
}

export interface GetAntrepoOfferListPagingAndFilterResponseFileArc {
    fileArchiveId: string
    entityId: string
    fileName: string
    url: string
    fileTypeId: string
    description: string
    fileTypeName: string
    createdDate: string
}

export const initialGetAntrepoOfferListPagingAndFilterResponseData: GetAntrepoOfferListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}